import React from "react";
import AddEditPaymentFormPage from "./AddEditPaymentFormPage";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface AddEditPaymentFormPageContainerProps extends RouteProps, withValidUserRoleProps {}

const AddEditPaymentFormPageContainer = (props: AddEditPaymentFormPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <AddEditPaymentFormPage title={getTitle()} category={getType()} />;
};

export default withValidUserRole(AddEditPaymentFormPageContainer);
